import { type ReactNode, useState } from 'react';
import cn from 'classnames';

import type { Vertical } from 'shared/search/common/config';

import styles from './HeroBanner.module.css';

interface HeroBannerProps {
    vertical: Vertical;
    children?: ReactNode;
}

export const HeroBanner = ({ vertical, children }: HeroBannerProps) => {
    const [hasError, setHasError] = useState(false);

    const base = 'https://images.finncdn.no/dynamic';
    const defaultImage = `${base}/640w_webp/travel/frontpage/herobanner_${vertical}.jpg`;

    return (
        <div className={cn(styles['hero-banner'], styles[`hero-banner--${vertical}`])}>
            <div
                className={cn(styles['hero-banner__image-wrapper'], styles[`hero-banner__image-wrapper--${vertical}`], {
                    [styles['hero-banner__image-wrapper--error']]: hasError,
                })}>
                <picture>
                    <source
                        type="image/webp"
                        srcSet={`
                            ${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg 320w,
                            ${base}/640w_webp/travel/frontpage/herobanner_${vertical}.jpg 640w,
                            ${base}/960w_webp/travel/frontpage/herobanner_${vertical}.jpg 960w,
                            ${base}/1280w_webp/travel/frontpage/herobanner_${vertical}.jpg 1280w
                        `}
                        sizes="100vw"
                    />

                    <img
                        className={cn(styles['hero-banner__image'], styles[`hero-banner__image--${vertical}`])}
                        src={defaultImage}
                        onError={() => setHasError(true)}
                        alt=""
                    />
                </picture>
            </div>
            <div className={styles['hero-banner__content-wrapper']}>{children}</div>
        </div>
    );
};
